import { Button } from "@heroui/react";
import { Link } from "@remix-run/react";
import { FiShoppingCart, FiPhoneCall } from "react-icons/fi";

function ContactUs({ title }: { title: React.ReactNode }) {
  return (
    <section className="lg:px-20 px-4 w-max-ppn bg-gray-50/50 dark:bg-gray-800/30 rounded-2xl py-10 md:py-12">
      <div className="my-8 w-full flex flex-col justify-center items-center gap-8 container mx-auto md:px-4">
        {title}
        <p className="text-sm md:text-base text-foreground/80 text-center max-w-xl">
          Get a custom quote in under 2 minutes. No obligation.
        </p>
        <div className="flex flex-col gap-5 text-justify md:text-center w-full md:w-10/12">
          <p>
            <a href="/" className="text-primary font-medium">
              Promotional Products Now
            </a>{" "}
            is a progressive promotional products company founded on the belief that customer
            satisfaction is of paramount and continuing importance.
          </p>
          <p>
            Serving all organizations around Australia for over 20 years, our success to date is
            directly contributed to the feedback received from our customers. Together with our
            proven cost-saving strategies, which have driven down prices, you can be assured our
            service, price, and product quality you receive from us will not be matched by our
            competitors.
          </p>
          <p>
            We are bound by the Code of Conduct of the Australasian Promotional Products Association
            and together with our 5 Rock Solid Guarantees, you are well and truly protected in the
            unlikely event something goes wrong with your order.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center items-center">

          <Button
            as={Link}
            to="/"
            size="lg"
            variant="bordered"
            startContent={<FiShoppingCart className="text-base" />}
            className="rounded-lg border-2 font-medium"
          >
            Shop now
          </Button>
          <Button
            as={Link}
            to="tel:1300664999"
            size="lg"
            variant="bordered"
            startContent={<FiPhoneCall className="text-base" />}
            className="rounded-lg border-2 border-primary text-primary font-medium"
            aria-label="Call us at 1300 664999"
          >
            Call 1300 664999
          </Button>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
